import { boot } from "@kit/boot";
import { game } from "./index";
import "./duvar.css";

boot({ id: game.meta.id, scenes: game.scenes, background: 0x1b1f3a });
